import { UserJsVm } from 'app/shared/generated/Administration/Models/UserJsVm';
import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { PermissionProfileEnum } from 'app/core/enums/generated/PermissionProfileEnum';

export const getAdminNav: () => NavRoute = () => {
	return {
		name: 'Admin'
		, security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
		, children: getChildrenNavRoutes()
	}
}

function getChildrenNavRoutes(): NavRoute[] {
    const user = getUser();
    let navRoutes: NavRoute[] = [
        { 
            name: 'Assets'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , children: [
                { 
                    name: 'Asset List'
                    , security: s => s?.permissionProfile === PermissionProfileEnum.Admin
                    , exact: true
                    , path: 'administration/assets' 
                }
                , { 
                    name: 'Asset Types'
                    , security: s => s?.permissionProfile === PermissionProfileEnum.Admin
                    , path: 'administration/asset-types' 
                }					
            ]
        }
        , {
            name: 'Barcodes'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/barcode-list'
        }
        , { 
            name: 'Clients'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/clients' 
        }
        , {
            name: 'Domiciles'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/domiciles'
        }
        , {
            name: 'Emergency Events'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/emergency-events'
        }
        , { 
            name: 'Fuel Types'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/fuel-types' 
        }
        , {
            name: 'Release Notes'
            , security: s => s?.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/release-notes/web-release-notes-list' 
        }
        , {
            name: 'Units'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/unit-list'
        }
        , {
            name: 'Users'
            , security: s => s?.permissionProfile === PermissionProfileEnum.Admin
            , children: [
                { 
                    name: 'User List'
                    , security: s => s?.permissionProfile === PermissionProfileEnum.Admin
                    , exact: true
                    , path: 'administration/users' 
                }
                , { 
                    name: 'Login History'
                    , security: s => s?.permissionProfile === PermissionProfileEnum.Admin
                    , path: 'administration/users/login-history' 
                }
            ]
        }
    ];

    if (user?.email?.includes("@paulconsulting.com")) {
        navRoutes.push({ 
            name: 'Strich Management'
            , security: sec => sec.permissionProfile === PermissionProfileEnum.Admin
            , exact: true
            , path: 'administration/strich-management' 
        });
    }

    return navRoutes;
}

function getUser(): UserJsVm {
	const userJson: string = localStorage.getItem('user');
	if (userJson !== null) { return JSON.parse(userJson); }
	return null;
}